import {
  faDollar,
  faEuroSign,
  faSterlingSign,
} from '@fortawesome/pro-solid-svg-icons';

import type { SupportedCurrency } from '__generated__/globalTypes';
import { FiatCurrency } from '__generated__/globalTypes';
import type { IconDefinition } from 'atoms/icons';

export const fiatCurrencySymbols: Record<FiatCurrency, string> = {
  [FiatCurrency.EUR]: '€',
  [FiatCurrency.GBP]: '£',
  [FiatCurrency.USD]: '$',
};

export const faFiatCurrencySymbols: Record<FiatCurrency, IconDefinition> = {
  [FiatCurrency.EUR]: faEuroSign,
  [FiatCurrency.GBP]: faSterlingSign,
  [FiatCurrency.USD]: faDollar,
};

export const isFiatCurrency = (
  value: SupportedCurrency
): value is FiatCurrency => {
  return Object.values(FiatCurrency).includesValue(value);
};
